module.exports = __webpack_public_path__ + "static/media/6.20e68a00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/6.jpg
// module id = 241
// module chunks = 0